import { useForm } from "react-hook-form";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { DefaultFormAutocomplete } from "../../../../../../common/components/default_form_autocomplete";
import { ObraEstruturaOrganizacionalForm, ObraEstruturaOrganizacionalSchema } from "../../../schemas/Obras_informacoesgerais/obra_estrutura_organizacional";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { ObraEstruturaOrganizacional } from "../../../../domain/models/obra_estrutura_organizacional";
import { ObraEstruturaOrganizacionalFuncionario } from "../../../../domain/models/obra_estrutura_organizacional_funcionario";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import FormContainer from "../../../../../../common/components/form_container";

/**
 * EstOrgModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  selectedEstOrg: ObraEstruturaOrganizacional | null,
  funcionariosDropdown: ObraEstruturaOrganizacionalFuncionario[],
  onClose: () => void;
  onSubmit: (e: ObraEstruturaOrganizacionalForm) => void;
};

export const EstOrgModal = ({
  open,
  saving,
  loading,
  selectedEstOrg,
  funcionariosDropdown,
  onClose,
  onSubmit,
}: Props) => {
  const hookForm = useForm<ObraEstruturaOrganizacionalForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(ObraEstruturaOrganizacionalSchema),
  });

  const [idFuncionario] = hookForm.watch(['idFuncionario']);

  useEffect(() => {
    if (open) {
      if (selectedEstOrg) {
        if (selectedEstOrg.idFuncionario) {
          hookForm.setValue('idFuncionario', selectedEstOrg.idFuncionario);
          hookForm.setValue('idCargo', selectedEstOrg.idFuncionario);
        }
      } else {
        hookForm.reset();
      }
    }
  }, [
    open,
    selectedEstOrg,
    hookForm,
  ]);

  useEffect(() => {
    let cargo = '';
    if (funcionariosDropdown) {
      const f = funcionariosDropdown.find(x => x.idFuncionario === idFuncionario);
      if (f) {
        cargo = f.cargo;
        hookForm.setValue('idCargo', f.idCargo);
      }
    }
    hookForm.setValue('cargo', cargo);
  }, [
    idFuncionario,
    hookForm,
    funcionariosDropdown,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title={'Estutura Organizacional'}
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <FormContainer title={"Informações"} arrangement="fullRow">
        <>
          <DefaultFormAutocomplete
            name='idFuncionario'
            label='Nome'
            options={funcionariosDropdown}
            getOptionDisabled={x => !x.canBeSelected}
            getOptionLabel={x => x.nome}
            getOptionKey={x => x.idFuncionario}
            reactHookForm={hookForm} />

          <DefaultFormInput
            name='cargo'
            label='Cargo'
            readOnly={true}
            reactHookForm={hookForm} />
        </>
      </FormContainer>
    </BaseFormControlledModal>
  );
}